import { render, staticRenderFns } from "./yz_wt_fapiao.vue?vue&type=template&id=b8740f90&scoped=true"
import script from "./yz_wt_fapiao.vue?vue&type=script&lang=js"
export * from "./yz_wt_fapiao.vue?vue&type=script&lang=js"
import style0 from "./yz_wt_fapiao.vue?vue&type=style&index=0&id=b8740f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8740f90",
  null
  
)

export default component.exports